import React from "react"
import {
  FeedGalleryListBlock,
  FeedNotExistTxtBlock,
  FeedNotExistTxt,
  FeedGalleryItemLink,
} from "./style"

import FeedGalleryItem from "components/presenters/feed/gallery/FeedGalleryItem"

const FeedGalleryList = ({ userInfo, feedList, onSelect }) => {
  if (feedList.length === 0)
    return (
      <FeedNotExistTxtBlock>
        <FeedNotExistTxt></FeedNotExistTxt>
      </FeedNotExistTxtBlock>
    )
  return (
    <FeedGalleryListBlock>
      {feedList.map((feedItem) => (
        <FeedGalleryItemLink
          onClick={() => {
            if (onSelect) onSelect(feedItem)
          }}
          key={`feed-list-item-no-${feedItem["no"]}`}
        >
          <FeedGalleryItem userInfo={userInfo} feedItem={feedItem} />
        </FeedGalleryItemLink>
      ))}
    </FeedGalleryListBlock>
  )
}

export default FeedGalleryList
